const Config = {
  BaseURL: 'https://api.cloudcabinet.jp/',
  tokenErrorMsg: '一定時間操作されなかったため、タイムアウトしました。\nログインし直してください。\n初めてログインされる方はそのままOKボタンをクリックしてください。',
  appVersion: '1.13.0 (e233b62f)',
};

export default Config;
